<template>
    <div class="orb-business-panel">
    <div class="border">
      <div class="header">
        <div class="header-text">
          <div class="pt-kicker">业务面板</div>
          <p class="card-title">{{ title }}</p>
        </div>
        <button class="close" @click="closeClick">&times;</button>
      </div>

      <!-- 操作区 -->
      <div class="controls">
        <button class="btn-primary" @click="addNotice">新增公告</button>
        <button class="btn" @click="refreshList">刷新</button>

        <input
            class="search"
            v-model="keyword"
            placeholder="搜索公告标题、内容或发布人"
        />
      </div>

      <!-- 公告列表 -->
      <div class="table-container">
        <table class="notice-table">
          <thead>
          <tr>
            <th>标题</th>
            <th>发布人</th>
            <th>类型</th>
            <th>状态</th>
            <th>发布时间</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="n in filteredList" :key="n.id">
            <td class="title-td" @click="viewNotice(n)">{{ n.title }}</td>
            <td>{{ n.publisher }}</td>
            <td>
              <span :class="['tag', typeClass(n.type)]">{{ n.type }}</span>
            </td>
            <td>
              <span :class="['tag', statusClass(n.status)]">{{ n.status }}</span>
            </td>
            <td>{{ n.time }}</td>
            <td>
              <button class="mini-btn" @click="topNotice(n)">置顶</button>
              <button class="mini-btn danger" @click="deleteNotice(n)">删除</button>
              <button class="mini-btn" @click="markRead(n)">已读</button>
            </td>
          </tr>

          <tr v-if="filteredList.length === 0">
            <td colspan="6" class="empty">暂无公告</td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- 公告详情 -->
      <div v-if="detail" class="detail-box">
        <div class="detail-window">
          <h3>{{ detail.title }}</h3>
          <p class="meta">
            发布人：{{ detail.publisher }} ｜ 发布时间：{{ detail.time }}
          </p>
          <div class="content">{{ detail.content }}</div>

          <div class="detail-btns">
            <button class="btn" @click="detail = null">关闭</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "noticeCard",
  data() {
    return {
      title:"通知公告",
      keyword: "",
      detail: null,
      notices: [
        {
          id: 1,
          title: "关于本周设备检修的通知",
          content: "本周六将对主要输水泵房进行计划检修，请相关部门提前准备。",
          publisher: "调度中心",
          type: "运维",
          status: "未读",
          time: "2025-01-10",
          top: false
        },
        {
          id: 2,
          title: "春节期间值班安排",
          content: "春节期间采用轮值制度，请同事们查看具体排班表。",
          publisher: "行政部",
          type: "行政",
          status: "已读",
          time: "2025-01-05",
          top: true
        },
        {
          id: 3,
          title: "关于水源地巡视的提醒",
          content: "近期气温较低，巡查需注意路面结冰安全。",
          publisher: "安全部",
          type: "安全",
          status: "未读",
          time: "2025-01-03",
          top: false
        }
      ]
    };
  },
  computed: {
    filteredList() {
      const k = this.keyword.trim().toLowerCase();
      let list = this.notices;

      if (k) {
        list = list.filter(item =>
            (item.title + item.content + item.publisher)
                .toLowerCase()
                .includes(k)
        );
      }

      // 置顶优先
      return list.sort((a, b) => b.top - a.top);
    }
  },
  methods: {
    closeClick() {
      this.$emit("infoClose");
    },
    addNotice() {
      const title = prompt("输入公告标题：");
      if (!title) return;

      this.notices.unshift({
        id: Date.now(),
        title,
        content: "这里是公告内容，可根据需要补充。",
        publisher: "系统管理员",
        type: "通知",
        status: "未读",
        time: new Date().toISOString().slice(0, 10),
        top: false
      });
    },
    viewNotice(n) {
      this.detail = n;
      n.status = "已读";
    },
    topNotice(n) {
      this.notices.forEach(t => (t.top = false));
      n.top = true;
    },
    deleteNotice(n) {
      if (!confirm("确认删除该公告？")) return;
      this.notices = this.notices.filter(x => x !== n);
    },
    markRead(n) {
      n.status = "已读";
    },
    refreshList() {
      alert("模拟刷新：公告状态已更新");
    },
    typeClass(t) {
      return {
        行政: "tag-blue",
        运维: "tag-green",
        安全: "tag-yellow",
        通知: "tag-cyan"
      }[t];
    },
    statusClass(s) {
      return s === "未读" ? "tag-red" : "tag-gray";
    }
  }
};
</script>

<style scoped>

.orb-business-panel {
  width: min(1040px, calc(100vw - 230px));
  height: calc(100vh - 150px);
  position: absolute;
  left: 50%;
  top: 112px;
  transform: translateX(-54%);
  z-index: 9998;
}

.border {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(8, 18, 32, 0.96), rgba(13, 38, 50, 0.94));
  border-radius: 10px;
  margin-top: 0;
  padding: 18px;
  box-sizing: border-box;
  color: #eef7ff;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(99, 179, 237, 0.28);
  box-shadow: 0 18px 52px rgba(0, 0, 0, 0.42);
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.header-text {
  flex: 1;
}

.card-title {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin: 0;
}

.close {
  width: 30px;
  height: 30px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.72);
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, border-color 0.2s;
}
.close:hover {
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.28);
}

.controls {
  display: flex;
  align-items: center;
  margin: 15px 0;
  gap: 10px;
}

.btn,
.btn-primary {
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  border: none;
}

.btn {
  background: rgba(255, 255, 255, 0.08);
  color: #d3f6ff;
}

.btn-primary {
  background: rgba(56, 189, 248, 0.12);
  color: #b8ecff;
  border: 1px solid rgba(56, 189, 248, 0.32);
}

.search {
  flex: 1;
  padding: 6px 8px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #e3ffff;
}

.notice-table {
  width: 100%;
  border-collapse: collapse;
}

.notice-table th,
.notice-table td {
  padding: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.title-td {
  cursor: pointer;
  color: #76d9ff;
  font-weight: bold;
}

.title-td:hover {
  text-decoration: underline;
}

.tag {
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 11px;
}

.tag-blue {
  background: rgba(0, 119, 255, 0.15);
  color: #7bbfff;
}

.tag-green {
  background: rgba(0, 255, 136, 0.15);
  color: #9fffe0;
}

.tag-yellow {
  background: rgba(255, 221, 0, 0.15);
  color: #fff5b3;
}

.tag-cyan {
  background: rgba(0, 255, 255, 0.15);
  color: #caffff;
}

.tag-red {
  background: rgba(255, 50, 50, 0.15);
  color: #ffb4b4;
}

.tag-gray {
  background: rgba(255, 255, 255, 0.1);
  color: #d1d1d1;
}

.mini-btn {
  padding: 4px 6px;
  font-size: 12px;
  margin-right: 4px;
  border-radius: 4px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.08);
  color: #e3ffff;
}

.danger {
  background: rgba(255, 80, 80, 0.15) !important;
  color: #ffc6c6 !important;
}

/*详情弹层*/
.detail-box {
  position: absolute;
  inset: 0;
  backdrop-filter: blur(4px);
  background: rgba(0, 0, 0, 0.2);
}

.detail-window {
  position: absolute;
  width: 70%;
  left: 15%;
  top: 10%;
  background: linear-gradient(135deg, rgba(8, 18, 32, 0.98), rgba(13, 38, 50, 0.96));
  border: 1px solid rgba(99, 179, 237, 0.28);
  border-radius: 10px;
  padding: 20px;
  color: #eef7ff;
}

.meta {
  font-size: 13px;
  margin-bottom: 10px;
  opacity: 0.8;
}

.detail-btns {
  margin-top: 15px;
  text-align: right;
}

.empty {
  text-align: center;
  padding: 20px;
  color: #9ed0da;
}
</style>
